import httpMethod from '../assets/js/http'
let http = httpMethod.methods

const actions = {
  showLeftMenu ({ commit }, status) {
    commit('showLeftMenu', status)
  },
  setMenus({ commit }, menus) {
    commit('setMenus', menus)
  },
  setRules({ commit }, rules) {
    commit('setRules', rules)
  },
  setUsers({ commit }, users) {
    commit('setUsers', users)
  },
  setDocumentTitle({ commit }, title) {
    commit('setDocumentTitle', title)
  },
  setUserGroups({ commit }, userGroups) {
    commit('setUserGroups', userGroups)
  },
  setOrganizes({ commit }, organizes) {
    commit('setOrganizes', organizes)
  },
  setMenusUpdate({ commit }, menusUpdate) {
    commit('setMenusUpdate', menusUpdate)
  },
  updateMenusList({ commit }) {
    let postData = {
      params: {
        type: 1
      }
    }
    if (Lockr.get('IS_LOG') == '1' && !store.state.isSetLog) {
      commit('setIsSetLog', true)
      postData.params.is_login = 1
    }
    http.apiGet('admin/menus', postData).then((res) => {
      if (res.code == 200) {
        commit('updateMenusList', res.data)
        commit('setMenusUpdate', true)
      } else {
        _g.dealError(this, res)
      }
    })
  },
  setMessageUnRead({ commit }) {
    http.apiGet(`msg/center/pending`).then((res) => {
      if (res.code === 200) {
        let isUnRead
        if (res.data > 0) {
          isUnRead = true
        } else {
          isUnRead = false
        }
        commit('setMessageUnRead', isUnRead)
      }
    })
  },
  openImportDialog({ commit }, isImportDialogUpdate) {
    commit('openImportDialog', isImportDialogUpdate)
  },
  closeImportDialog({ commit }, isImportDialogClose) {
    commit('closeImportDialog', isImportDialogClose)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js